<template>
  <div>
    <div class="col-md-10 mx-auto">
      <h1 class="display-4">Welkom!</h1>
      <p>
        Welkom, Linus, in onze wereld! We hebben lang op je gewacht en naar je uitgekeken, en daar was je plots.
      </p>
      <p>
        4 weken te vroeg, maar heel erg welkom, kunnen wij je nu in onze armen nemen.
      </p>
      <p>Wij kijken er naar uit je te leren kennen!</p>
      <br>
      <button class="btn btn-info" @click="$router.push('/homeEditor')" v-if="currentUser && currentUser.email">Edit</button>
      <div class="mt-3">
          <a :href="img.img" target="_blank" v-for="(img, idx) in sortedCarousel" :key="'homeImg_'+idx" :data-index="idx">
            <progressive-img
              class="card-img-top img-fluid m-0"
              :src="img.img"
              :placeholder="img.img_thumb"
              :aspect-ratio="img.ratio"
            ></progressive-img>
          </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["homeCarousel", "currentUser"]),
    sortedCarousel(){
      return this.$_.sortBy(this.homeCarousel, "order")
    }
  },
};
</script>

